var exports = {
  "q": "x127c5a35--a15272--factoids-container",
  "F": "x127c5a35--a15272--factoid",
};

module.exports = exports;
